<template>
  <div
    v-if="valeur"
    :class="$vuetify.breakpoint.mobile ? 'py-3 px-1' : 'px-1 align-self-center fixed-width'"
  >
    <!-- Tant qu'une saisie est en erreur ailleurs, la cellule reste visible
         mais desactivee : un tooltip explique pourquoi elle ne repond pas. -->
    <v-tooltip
      v-if="enErreur"
      top
    >
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-btn
            class="mb-3"
            outlined
            color="#D7D8D6"
            rounded
            disabled
            width="100%"
            height="55"
          >
            <div
              class="intro text-gris-fonce align-self-center mx-auto"
              :class="$vuetify.breakpoint.mobile ? ' text-truncate max-width-105' : ''"
            >
              {{ valeur }}
            </div>
            <v-icon
              right
              size="22"
              color="#646363"
            >
              mdi-pencil-outline
            </v-icon>
          </v-btn>
        </div>
      </template>
      {{ MESSAGE_ERREUR }}
    </v-tooltip>

    <v-btn
      v-else
      class="mb-3"
      outlined
      color="#D7D8D6"
      rounded
      width="100%"
      height="55"
      @click="$emit('modifier')"
    >
      <div
        class="intro text-gris-fonce align-self-center mx-auto"
        :class="$vuetify.breakpoint.mobile ? ' text-truncate max-width-105' : ''"
      >
        {{ valeur }}
      </div>
      <v-icon
        right
        size="22"
        color="#646363"
      >
        mdi-pencil-outline
      </v-icon>
    </v-btn>
  </div>

  <!-- Sans valeur, la colonne reste occupee pour que les cultures voisines
       gardent leur alignement. -->
  <div
    v-else
    class="intro text-gris-fonce"
    :class="$vuetify.breakpoint.mobile ? '' : 'fixed-width'"
  >
    <div class="align-center" />
  </div>
</template>
<script>
/*
 * Cellule d'une ligne d'itineraire technique : affiche une valeur et ouvre
 * une modale de saisie au clic.
 *
 * Le meme bloc figurait six fois dans l'ecran du comparateur - engrais et
 * traitements, pour chacune des trois cultures comparees - recopie
 * integralement a chaque fois, soit plus de soixante lignes par occurrence.
 *
 * A noter : la version d'origine posait un @click sur le bouton desactive
 * de la variante en erreur. Un v-btn desactive n'emet pas d'evenement, ce
 * gestionnaire ne s'est donc jamais declenche ; il n'est pas repris ici.
 */
const MESSAGE_ERREUR = 'Veuillez corriger l\'erreur avant de continuer votre saisie'

export default {
  name: 'CelluleModifiable',
  props: {
    // Texte affiche ; une valeur vide laisse la colonne vide mais presente
    valeur: {
      type: [String, Number],
      default: null
    },
    // Une saisie en erreur ailleurs bloque la modification
    enErreur: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { MESSAGE_ERREUR }
  }
}
</script>
